// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarHeader_wrapper__tuCNv","title":"SidebarHeader_title__7P6vc","imgHolder":"SidebarHeader_imgHolder__vcVk1","action":"SidebarHeader_action__1T2ky"};